import React, { createContext, useContext, useMemo } from "react";

type HeaderContextValue = {
  hideHeader: boolean;
  onClose?: () => void;
};

const HeaderContext = createContext<HeaderContextValue>({ hideHeader: false });

export const useHeaderContext = () => useContext(HeaderContext);

type HideHeaderProps = {
  children: React.ReactNode;
  onClose?: () => void;
};

export const HideHeader: React.FC<HideHeaderProps> = ({
  children,
  onClose,
}) => (
  <HeaderContext.Provider
    value={useMemo(() => ({ hideHeader: true, onClose }), [onClose])}
  >
    {children}
  </HeaderContext.Provider>
);
